module.exports = __webpack_public_path__ + "static/media/link_icon.14ecfe53.svg";